import {AssertUtils} from "goingutils";
import EditorTypeUtils from './editorTypeUtils';


function _closeMoreQuery(moreCtl) {
    $("#" + moreCtl.moreQueryPanelId)
        .removeClass("fadeInRight")
        .addClass("fadeOutRight");
    setTimeout(function () {
        $("#" + moreCtl.moreQueryPanelId).hide();
    }, 300);
    $(".more-query-cover").remove();
}


export default function _initMoreQueryEvent(containerId, moreCtl) {
    //点击取消按钮
    $(`#${containerId}_cancelBtn,#${containerId}_header_icon`).click(function () {
        _closeMoreQuery(moreCtl);
    });
    //点击清空按钮
    $(`#${containerId}_clearBtn`).click(function () {
        moreCtl.goingFrom.clearData();
    });

    //点击遮罩 关闭相应的查询区域
    $(".more-query-cover").click(function () {
        _closeMoreQuery(moreCtl);
    });

    //点击确定按钮
    $(`#${containerId}_confirm`).click(function () {
        _closeMoreQuery(moreCtl);

        let querySubmitJson = {};
        moreCtl.queryAry.forEach(function (item) {
            EditorTypeUtils.getSubmitDataByItem(
                item,
                querySubmitJson,
                "query",
                moreCtl
            );
        });
        moreCtl.vueObj.$emit("searchFun", {datas: querySubmitJson});
        if (AssertUtils.isNotNull(moreCtl.searchFun)) {
            moreCtl.searchFun({datas: querySubmitJson});
        }
    });
}




// WEBPACK FOOTER //
// ./goingsrc/common/initMoreQueryEvent.js